import { DartsGameType } from "../common/types/DartsGameTypes";
import IUser from "../common/interfaces/IUser";
import { UserState } from "../state/auth/UserState.type";

export function StringToDartsGameType(type: string | undefined): DartsGameType | undefined {
    if (type && type.toUpperCase() in DartsGameType) {
        return DartsGameType[type.toUpperCase() as keyof typeof DartsGameType];
    }
    return undefined;
}

export const UserStateToIUser = (state: UserState): IUser => {
    return {
        id: state.id,
        name: state.name,
        email: state.email,
        roles: [],
        permissions: [],
        client: null
    };
};

export const IUserToUserState = (user: IUser): UserState => {
    return {
        id: user.id,
        name: user.name,
        email: user.email,
        isAllowed: false,
        is2FA: false,
        isPrivate: true,
    };
};

export function mapJsonToRecordStringBoolean(json: any): Record<string, boolean> {
    const result: Record<string, boolean> = {};
    for (const key in json) {
        const value = json[key];
        result[key] = Boolean(value);
    }
    return result;
}

export function mapJsonToRecord(json: any): Record<string, string> {
    const result: Record<string, string> = {};
    for (const key in json) {
        const value = json[key];
        result[key] = value;
    }
    return result;
}
